import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const FYContext = createContext(null);

export function FYProvider({ children }) {
  const [currentFY, setCurrentFY] = useState("");
  const [fyLabel, setFyLabel] = useState("");
  const [availableFYs, setAvailableFYs] = useState([]);
  const [selectedFY, setSelectedFY] = useState("");

  const fetchFY = useCallback(async () => {
    try {
      const res = await api.get("/fy");
      setCurrentFY(res.data.current_fy);
      setFyLabel(res.data.label);
      setAvailableFYs(res.data.available);
      const saved = localStorage.getItem("stancor_fy");
      setSelectedFY(saved || res.data.current_fy);
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => { fetchFY(); }, [fetchFY]);

  const changeFY = (fy) => {
    setSelectedFY(fy);
    localStorage.setItem("stancor_fy", fy);
  };

  const selectedLabel = availableFYs.find(f => f.code === selectedFY)?.label || fyLabel;

  return (
    <FYContext.Provider value={{ currentFY, fyLabel, availableFYs, selectedFY, selectedLabel, changeFY }}>
      {children}
    </FYContext.Provider>
  );
}

export const useFY = () => {
  const ctx = useContext(FYContext);
  if (!ctx) throw new Error("useFY must be used within FYProvider");
  return ctx;
};
